// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo {
   display: block;
   height: 26px;
   margin: 0 auto 30px;
}

form {
   background-color: #fff;
   border: 1px solid rgba(0, 0, 0, .1);
   /* margin: auto; */
   padding: 30px 40px;
   position: relative;
   width: 100%;
   max-width: 440px;
   min-width: 380px;
}

.clearfix:before, .clearfix:after {
   content: " ";
   display: table;
}

.external-sign-header {
   float: left;
   font-size: 20px;
}

.external-sign-content-new {
   margin-top: 6px;
   margin-bottom: 1em;
   text-align: center;
}

.external-sign-content {
   margin-top: 6px;
   margin-bottom: 5px;
   text-align: center;
}

.external-sign-content-textresend {
   margin-bottom: 1em;
   text-align: center;
}

.external-sign-ref {
   min-height: 32px;
}

label {
   color: #aaa;
   display: block;
   font-weight: normal;
   margin-top: .5em;
   margin-bottom: 2px;
}

.mat-form-field {
   width: 100%;
}

input[type=text], input[type=password], input[type=email] {
   border: 1px solid rgba(0, 0, 0, .1);
   border-radius: 2px;
   font-size: 16px;
   outline: none;
   padding-left: 5px;
   padding-top: 2px;
   padding-bottom: 2px;
   width: 100%;
}

input:-webkit-autofill {
   -webkit-border-start-color: #e5e5e5;
   -webkit-border-end-color: #e5e5e5;
   -webkit-border-after-color: #e5e5e5;
   -webkit-border-before-color: #e5e5e5;
   -webkit-box-shadow: 0 0 0 1000px white inset;
}

input + label {
   margin-top: 10px;
}

.external-sign-button {
   box-shadow: none !important;
   margin-top: 1em !important; /* !important overwrites 'margin: 0' from button.css */
}

@media screen and (max-width: 400px) {
   .container {
      display: block;
      float: none;
      margin-top: 70px;
      width: 320px;
   }
}

/* Add padding to container elements */
.container {
   padding: 16px;
}

/* Clear floats */
.clearfix::after {
   content: "";
   clear: both;
   display: table;
}

.wait, .wait *, .wait a {
   cursor: wait;
}

p {
   width: 100%;
   margin: 0;
   padding: 0;
   text-align: center;
}

.fancy {
   margin: 2em 0;
   text-align: center;
}

.fancy span {
   display: inline-block;
   position: relative;
   text-transform: capitalize;
}

.fancy span:before,
.fancy span:after {
   border-bottom: 1px solid #ccc;
   content: "";
   position: absolute;
   top: 11px;
   max-width: 140px;
   min-width: 130px;
}

.fancy span:before {
   right: 100%;
   margin-right: 15px;
}

.fancy span:after {
   left: 100%;
   margin-left: 15px;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

.menu-button{
   padding: 1px 6px 1px 6px;
}

.actions-req-otp {
   text-align: center;
}

.actions-req-otp button {
   border: 1px solid #2AB4C0;
   background-color: #fff;
   color: #36c6d3;
   cursor: pointer;
   width: 190px;
}
.actions-req-otp button + button {
   margin-left: 2em;
}
.actions-req-otp img, .actions-req-otp svg {
   height: 20px;
   margin-right: 8px;
   width: 20px;
}
.actions-req-otp img, .actions-req-otp span {
   display: inline-block;
   vertical-align: middle;
}

.actions-req-otp button:disabled {
   border: 1px solid #ccc;
   background-color: #f5f5f5;
   color: #aaa;
   cursor: not-allowed;
   opacity: 0.6;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/external-sign/external-sign.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;GACd,YAAY;GACZ,mBAAmB;AACtB;;AAEA;GACG,sBAAsB;GACtB,mCAAmC;GACnC,kBAAkB;GAClB,kBAAkB;GAClB,kBAAkB;GAClB,WAAW;GACX,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,cAAc;GACd,mBAAmB;GACnB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,mCAAmC;GACnC,kBAAkB;GAClB,eAAe;GACf,aAAa;GACb,iBAAiB;GACjB,gBAAgB;GAChB,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,mCAAmC;GACnC,iCAAiC;GACjC,mCAAmC;GACnC,oCAAoC;GACpC,4CAA4C;AAC/C;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,2BAA2B;GAC3B,0BAA0B,EAAE,sDAAsD;AACrF;;AAEA;GACG;MACG,cAAc;MACd,WAAW;MACX,gBAAgB;MAChB,YAAY;GACf;AACH;;AAEA,sCAAsC;AACtC;GACG,aAAa;AAChB;;AAEA,iBAAiB;AACjB;GACG,WAAW;GACX,WAAW;GACX,cAAc;AACjB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,WAAW;GACX,SAAS;GACT,UAAU;GACV,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,kBAAkB;GAClB,0BAA0B;AAC7B;;AAEA;;GAEG,6BAA6B;GAC7B,WAAW;GACX,kBAAkB;GAClB,SAAS;GACT,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,kBAAkB;AACrB;;AAEA;GACG,UAAU;GACV,iBAAiB;AACpB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,sBAAsB;GACtB,cAAc;GACd,eAAe;GACf,YAAY;AACf;AACA;GACG,gBAAgB;AACnB;AACA;GACG,YAAY;GACZ,iBAAiB;GACjB,WAAW;AACd;AACA;GACG,qBAAqB;GACrB,sBAAsB;AACzB;;AAEA;GACG,sBAAsB;GACtB,yBAAyB;GACzB,WAAW;GACX,mBAAmB;GACnB,YAAY;AACf","sourcesContent":[".logo {\n   display: block;\n   height: 26px;\n   margin: 0 auto 30px;\n}\n\nform {\n   background-color: #fff;\n   border: 1px solid rgba(0, 0, 0, .1);\n   /* margin: auto; */\n   padding: 30px 40px;\n   position: relative;\n   width: 100%;\n   max-width: 440px;\n   min-width: 380px;\n}\n\n.clearfix:before, .clearfix:after {\n   content: \" \";\n   display: table;\n}\n\n.external-sign-header {\n   float: left;\n   font-size: 20px;\n}\n\n.external-sign-content-new {\n   margin-top: 6px;\n   margin-bottom: 1em;\n   text-align: center;\n}\n\n.external-sign-content {\n   margin-top: 6px;\n   margin-bottom: 5px;\n   text-align: center;\n}\n\n.external-sign-content-textresend {\n   margin-bottom: 1em;\n   text-align: center;\n}\n\n.external-sign-ref {\n   min-height: 32px;\n}\n\nlabel {\n   color: #aaa;\n   display: block;\n   font-weight: normal;\n   margin-top: .5em;\n   margin-bottom: 2px;\n}\n\n.mat-form-field {\n   width: 100%;\n}\n\ninput[type=text], input[type=password], input[type=email] {\n   border: 1px solid rgba(0, 0, 0, .1);\n   border-radius: 2px;\n   font-size: 16px;\n   outline: none;\n   padding-left: 5px;\n   padding-top: 2px;\n   padding-bottom: 2px;\n   width: 100%;\n}\n\ninput:-webkit-autofill {\n   -webkit-border-start-color: #e5e5e5;\n   -webkit-border-end-color: #e5e5e5;\n   -webkit-border-after-color: #e5e5e5;\n   -webkit-border-before-color: #e5e5e5;\n   -webkit-box-shadow: 0 0 0 1000px white inset;\n}\n\ninput + label {\n   margin-top: 10px;\n}\n\n.external-sign-button {\n   box-shadow: none !important;\n   margin-top: 1em !important; /* !important overwrites 'margin: 0' from button.css */\n}\n\n@media screen and (max-width: 400px) {\n   .container {\n      display: block;\n      float: none;\n      margin-top: 70px;\n      width: 320px;\n   }\n}\n\n/* Add padding to container elements */\n.container {\n   padding: 16px;\n}\n\n/* Clear floats */\n.clearfix::after {\n   content: \"\";\n   clear: both;\n   display: table;\n}\n\n.wait, .wait *, .wait a {\n   cursor: wait;\n}\n\np {\n   width: 100%;\n   margin: 0;\n   padding: 0;\n   text-align: center;\n}\n\n.fancy {\n   margin: 2em 0;\n   text-align: center;\n}\n\n.fancy span {\n   display: inline-block;\n   position: relative;\n   text-transform: capitalize;\n}\n\n.fancy span:before,\n.fancy span:after {\n   border-bottom: 1px solid #ccc;\n   content: \"\";\n   position: absolute;\n   top: 11px;\n   max-width: 140px;\n   min-width: 130px;\n}\n\n.fancy span:before {\n   right: 100%;\n   margin-right: 15px;\n}\n\n.fancy span:after {\n   left: 100%;\n   margin-left: 15px;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\n.menu-button{\n   padding: 1px 6px 1px 6px;\n}\n\n.actions-req-otp {\n   text-align: center;\n}\n\n.actions-req-otp button {\n   border: 1px solid #2AB4C0;\n   background-color: #fff;\n   color: #36c6d3;\n   cursor: pointer;\n   width: 190px;\n}\n.actions-req-otp button + button {\n   margin-left: 2em;\n}\n.actions-req-otp img, .actions-req-otp svg {\n   height: 20px;\n   margin-right: 8px;\n   width: 20px;\n}\n.actions-req-otp img, .actions-req-otp span {\n   display: inline-block;\n   vertical-align: middle;\n}\n\n.actions-req-otp button:disabled {\n   border: 1px solid #ccc;\n   background-color: #f5f5f5;\n   color: #aaa;\n   cursor: not-allowed;\n   opacity: 0.6;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
